import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict,
  platformTitleDict
} from '@/dictionary/system'

/**
 * 风险治理
 */
export default {
  path: 'risk',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '风险治理',
    layout: 'DefaultLayout',
    grayscale: 'risk'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
  roles: [
    platformFunctionModuleDict.RISK_GOVERNMENT.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 风险统计
    {
      path: 'board',
      name: 'RiskBoard',
      component: '/risk-views/board/index',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '风险统计',
        icon: 'icon-side-fengxiankanban'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.RISK_GOVERNMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 风险管理
    {
      path: 'manage',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '风险管理',
        icon: 'icon-side-fengxianguanli'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.RISK_GOVERNMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 风险目录
        {
          path: 'rulebase',
          name: 'RiskManageRulebase',
          component: '/risk-views/manage/rulebase/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '风险目录',
            cache: true,
            pageComponentName: 'RiskManageRulebase'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [
            { platformId: platformTitleDict.JXIC.value, menuName: '风险清单' }
          ],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.RISK_GOVERNMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 风险处置
        {
          path: 'handle',
          name: 'RiskManageHandle',
          component: '/risk-views/manage/handle/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '风险处置'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [
            { platformId: platformTitleDict.JXIC.value, menuName: '风险查询' }
          ],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.RISK_GOVERNMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 风险报表
        {
          path: 'report',
          name: 'RiskManageReport',
          component: '/risk-views/manage/report/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '风险报表'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.RISK_GOVERNMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    },

    // 风险画像
    {
      path: 'portrait',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '风险画像',
        icon: 'icon-side-fengxianhuaxiang'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.RISK_GOVERNMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 采购单位画像
        {
          path: 'purchaser',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '采购单位画像'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.RISK_GOVERNMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: [],

          children: [
            {
              path: 'list',
              name: 'RiskPortraitPurchase',
              component: '/risk-views/portrait/purchase/index',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '画像列表',
                cache: true,
                hidden: true,
                pageComponentName: 'RiskPortraitPurchase'
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.RISK_GOVERNMENT.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            },

            // 采购风险报告
            {
              path: 'company/:companyId/report',
              name: 'RiskPortraitPurchaseReport',
              component: '/risk-views/portrait/purchase/report',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '采购风险报告',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.RISK_GOVERNMENT.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            }
          ]
        },

        // 投标单位画像
        {
          path: 'supplier',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '投标单位画像'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.RISK_GOVERNMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: [],

          children: [
            {
              path: 'list',
              name: 'RiskPortraitSupplier',
              component: '/risk-views/portrait/supplier/index',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '画像列表',
                cache: true,
                hidden: true,
                pageComponentName: 'RiskPortraitPurchase'
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.RISK_GOVERNMENT.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            },

            // 投标风险报告
            {
              path: 'company/:companyId/report',
              name: 'RiskPortraitSupplierReport',
              component: '/risk-views/portrait/supplier/report',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '投标风险报告',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.RISK_GOVERNMENT.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            }
          ]
        },

        // 投标单位关系分析
        {
          path: 'relation',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '投标单位关系分析'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.RISK_GOVERNMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: [],

          children: [
            {
              path: 'list',
              name: 'RelationshipAnalysis',
              component: '/risk-views/portrait/relation/index',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '投标单位关系分析',
                cache: true,
                hidden: true,
                pageComponentName: 'RelationshipAnalysis'
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.RISK_GOVERNMENT.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            }
          ]
        }
      ]
    },

    // 招标项目详情
    {
      path: 'bid/orders/:orderId/detail',
      name: 'RiskBiddingProjectDetail',
      component: '/project-views/bidding/index',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '招标项目详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.RISK_GOVERNMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 招标文件详情
    {
      path: 'bid/orders/:orderId/file-info/:biddingFileId',
      name: 'RiskProjectInviteBidFileInfo',
      component:
        '/procure-views/purchase/invite-bid/invite-bid-detail/bid-file-detail',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '招标文件详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.RISK_GOVERNMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 询比项目详情
    {
      path: 'inquiry/orders/:orderId/detail',
      name: 'RiskInquiryProjectDetail',
      component: '/project-views/inquiry-project/index',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '询比项目详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.RISK_GOVERNMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 竞价项目详情
    {
      path: 'compete/orders/:orderId/detail',
      name: 'RiskCompeteProjectDetail',
      component: '/project-views/compete/index',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '竞价项目详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.RISK_GOVERNMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 谈判项目详情
    {
      path: 'negotiation/orders/:orderId/detail',
      name: 'RiskNegotiationProjectDetail',
      component: '/project-views/negotiation/index',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '询比项目详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.RISK_GOVERNMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 督办任务管理
    {
      path: 'supervise',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '督办任务管理',
        icon: 'icon-side_purchase_record'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.RISK_GOVERNMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        {
          path: 'task',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '任务查询',
            layout: 'DefaultLayout'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.RISK_GOVERNMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: [],

          children: [
            // 任务列表
            {
              path: 'list',
              name: 'RiskSuperviseTask',
              component: '/risk-views/supervise/task/index',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '任务列表',
                cache: true,
                hidden: true,
                pageComponentName: 'RiskSuperviseTask'
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.RISK_GOVERNMENT.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            }
          ]
        }
      ]
    },

    // 风险通知设置
    {
      path: 'notice-set',
      name: 'RiskNoticeSet',
      component: '/risk-views/notice-set/index',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '风险通知设置',
        icon: 'icon-message'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
      superviseInstitutions: []
    }
  ]
}
